import React from 'react';
import RoleListPage from '../RoleManagement/RoleListPage';
import { ROLE_CONFIGS } from '../RoleManagement/roleConfig';
import styles from './AgentPage.module.css';

const AgentPage: React.FC = () => (
  <RoleListPage config={ROLE_CONFIGS.agent} styles={styles} />
);

export default AgentPage;
